<template>
  <div>
    <div class="content-item flex">
      <p class="content-item-label"><span class="red">*</span>是否原创</p>
      <el-radio-group
        v-model="source"
        class="flex align-items-center"
        style="margin-left: 10px"
      >
        <el-radio :label="1" :disabled="disabled">原创</el-radio>
        <el-radio :label="2" :disabled="disabled">转载</el-radio>
      </el-radio-group>
      <p class="original-styles" v-if="!disabled && app_type == 'man'">
        <span v-if="tableData.length <= 0">
          <span class="black" v-if="articleOriginality"
            >文章原创度：<span class="red"
              >{{ this.articleOriginality }}%</span
            ></span
          >
          <span class="black" v-if="originalityCheckTime"
            >历史查重时间：{{ this.originalityCheckTime }}</span
          >
          {{ this.articleOriginalityText || "" }}
        </span>
        <!-- 3302：正在查重中，按钮禁止点击 -->
        <el-button
          type="default"
          v-if="articleOriginalityCode === '3302' && articleType == 1"
          disabled
          ><span class="button">查重中...</span></el-button
        >
        <el-button
          type="default"
          v-if="articleOriginalityCode !== '3302' && articleType == 1"
          @click="handleClick(2, 'riskSave')"
          ><span class="button">重新查重</span></el-button
        >
      </p>
      <slot></slot>
    </div>
    <div
      class="content-item flex"
      v-if="tableData.length > 0 && app_type == 'man'"
    >
      <p class="content-item-label"><span /></p>
      <span class="black" v-if="articleOriginality"
        >本文共{{ words }}字，原创度<span class="red"
          >{{ this.articleOriginality }}%</span
        ></span
      >
      <span class="black" v-if="originalityCheckTime"
        >历史查重时间：{{ this.originalityCheckTime }}</span
      >
      {{ this.articleOriginalityText || "" }}
    </div>
    <div
      class="content-item flex"
      v-if="tableData.length > 0 && app_type == 'man'"
    >
      <p class="content-item-label"><span /></p>
      <div class="item-table">
        <el-table :data="tableData" border size="mini" style="width: 100%">
          <el-table-column label="序号" type="index" align="center" width="60">
          </el-table-column>
          <el-table-column
            prop="vioTitle"
            label="侵权文章"
            align="center"
            width="240"
            show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="similarity"
            align="center"
            label="相似度"
            width="100"
          >
            <template slot-scope="scope">
              {{ `${(scope.row["similarity"] * 100).toFixed(0)}%` }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="侵权作者"
            align="center"
            show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="platform"
            label="侵权平台"
            align="center"
            show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button
                @click="redirectTo(scope.$index)"
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @sizePageChange="paginationChangeProduct"
          :paginationDatas="paginationDataProduct"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
// 写手端：user, 运营端: man, 超管端：admin
import {
  queryContentRiskControl,
  healthCmpBizPageDuplicateRecord,
} from "@/api/man";
import pagination from "../pagination";
var app_type = process.env.VUE_APP_TYPE;
export default {
  name: "articleSource",
  props: ["articleSource", "words", "articleType", "disabled"],
  data() {
    return {
      app_type,
      isArticleOriginaly: false,
      articleOriginality: "",
      articleOriginalityText: "",
      articleOriginalityCode: "",
      articleId: "",
      tableData: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 30, 50],
      },
    };
  },
  created() {
    this.articleId = this.$route.query.id;
    if (this.app_type == "man") {
      this.queryContentRiskControl(
        this.$route.query.id,
        this.$commonJs.getTenantId()
      );
      this.healthCmpBizPageDuplicateRecord(
        this.$route.query.id,
        this.$commonJs.getTenantId(),
        1,
        1,
        5
      );
    }
  },
  components: {
    pagination,
  },
  computed: {
    source: {
      get() {
        return this.articleSource;
      },
      set(val) {
        this.$emit("update:articleSource", val);
      },
    },
  },
  methods: {
    // 查重接口-------------------------------------
    queryContentRiskControl(contentId, tenantId) {
      queryContentRiskControl({ contentId, tenantId }).then((res) => {
        // 与后端协商达成一致，此接口有六种code，传回0000时，只显示原创度
        if (!res.code) {
          // axios公共工具函数不返回code时，即接口返回code === 0000
          this.articleOriginality = res.originality + "";
        } else {
          // 传回3300 | 3301 | 3302 | 3303 | 3304时，显示msg文案，若有历史原创度，显示文案+历史原创度
          // axios公共工具函数返回code时，即接口返回code === 3300 | 3301 | 3302 | 3303 | 3304
          this.isArticleOriginaly = false;
          this.articleOriginalityText = res.msg;
          this.articleOriginalityCode = res.code;
          if (res.data) {
            this.articleOriginality = res.data.originality + "";
            this.originalityCheckTime = res.data.originalityCheckTime;
          }
        }
      });
    },
    healthCmpBizPageDuplicateRecord(
      contentId,
      tenantId,
      sourceType,
      pageNo,
      pageSize
    ) {
      healthCmpBizPageDuplicateRecord({
        tenantId,
        contentId,
        sourceType,
        pageNo,
        pageSize,
      }).then((res) => {
        const { data, ...pageConfig } = res;
        this.tableData = data;
        this.paginationDataProduct = {
          ...this.paginationDataProduct,
          total: pageConfig.totalCount,
          currentPage: pageConfig.pageNo,
          pageSize: pageConfig.pageSize,
        };
      });
    },
    handleClick(arg, type) {
      this.$emit("repeatGetRecord", arg, type);
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.healthCmpBizPageDuplicateRecord(
        this.articleId,
        this.$commonJs.getTenantId(),
        1,
        this.paginationDataProduct.currentPage,
        this.paginationDataProduct.pageSize
      );
    },
    redirectTo(id) {
      let routeUrl = this.$router.resolve({
        path: `/contentTool/contentRecord`,
        query: {
          id: this.articleId,
          tenantid: this.$commonJs.getTenantId(),
          paragraphId: id,
          pageSizes: this.paginationDataProduct.pageSize,
          type: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
// 查重 ----------------------------
.content-item {
  .item-table {
    width: 902px;
  }
  .original-styles {
    margin-left: 15px;
    display: flex;
    align-items: center;

    &::before {
      content: "";
      display: block;
      margin-right: 10px;
      width: 2px;
      height: 15px;
      background-color: #606266;
    }
    span.black {
      color: #606266 !important;
    }
    .el-button {
      margin-left: 10px;
      padding: 10px;
      > span {
        margin: 0;
        line-height: 19.2px;
      }
      .button {
        margin: 0;
      }
    }
  }
}
.red {
  color: red;
}
.article .wrap .content-item :deep(.el-pagination__jump .el-input) {
  width: 50px;
}
.article .wrap .content-item :deep(.el-pagination__sizes .el-select .el-input) {
  width: 100px;
}
// 查重 ----------------------------
</style>
